import { TimeLineContent as Container } from "./styles";

export function TimeLineContent({ children }) {
  return <Container>{children}</Container>;
}
